import Transform from "./transform";
import { initializeGreenAndGrid } from "./initializeGreenAndGrid";

export const createViewMatrices = (width, height, hole) => {
  // Create the world to image transform
  var wToIarray = hole.WorldToImageTransform.split(",");
  var tWorldToImage = new Transform();
  tWorldToImage.m[0] = Number(wToIarray[0]);
  tWorldToImage.m[1] = Number(wToIarray[1]);
  tWorldToImage.m[2] = Number(wToIarray[2]);
  tWorldToImage.m[3] = Number(wToIarray[3]);
  tWorldToImage.m[4] = Number(wToIarray[4]);
  tWorldToImage.m[5] = Number(wToIarray[5]);

  // Create the image to world transform by inverting the world to image transform
  var tImageToWorld = new Transform();
  tImageToWorld.multiply(tWorldToImage); // Copy WorldToImage
  tImageToWorld.invert();

  // Check for unset boundaries.  This will be checked for initializing other items.
  var boundariesUnset =
    hole.GreenUpperLeft === "0,0" && hole.GreenLowerRight === "0,0";

  // Initialize boundaries of green view.
  var UL = hole.GreenUpperLeft.split(",");
  var LR = hole.GreenLowerRight.split(",");
  if (boundariesUnset) {
    // Create initial UL & LR
    UL = tImageToWorld.transformPoint(0, 0);
    LR = tImageToWorld.transformPoint(1024, 600);
    // Store new values locally
    hole.GreenUpperLeft = UL[0] + "," + UL[1];
    hole.GreenLowerRight = LR[0] + "," + LR[1];
  }

  var upperLeft = { X: Number(UL[0]), Y: Number(UL[1]) };
  var lowerRight = { X: Number(LR[0]), Y: Number(LR[1]) };

  var ptLocationUL = tWorldToImage.transformPoint(upperLeft.X, upperLeft.Y);
  var ptLocationLR = tWorldToImage.transformPoint(lowerRight.X, lowerRight.Y);

  var fScaleFactor;
  if (ptLocationLR[1] - ptLocationUL[1] > ptLocationLR[0] - ptLocationUL[0]) {
    fScaleFactor = height / (ptLocationLR[1] - ptLocationUL[1]);
  } else {
    fScaleFactor = width / (ptLocationLR[0] - ptLocationUL[0]);
  }

  var tViewToGreen = new Transform();
  tViewToGreen.scale(fScaleFactor, fScaleFactor);

  // Move to the upper left corner of canvas
  tViewToGreen.translate(-1 * ptLocationUL[0], -1 * ptLocationUL[1]);

  if (boundariesUnset) {
    // Not set yet - reset the viewToGreen transform
    tViewToGreen.m = [0.3, 0.0, 0.0, 0.3, 0.0, 0.0];
  }

  var tGreenToWorld = new Transform();
  tGreenToWorld.multiply(tImageToWorld); // Copy viewToGreen
  var tGreenToView = new Transform();
  tGreenToView.multiply(tViewToGreen);
  tGreenToView.invert();
  tGreenToWorld.multiply(tGreenToView);

  hole.CourseNumber = hole?.Course;
  hole.HoleNumber = hole?.Hole;
  hole.greenToWorld = tGreenToWorld;
  hole.worldToImage = tWorldToImage;
  hole.imageToWorld = tImageToWorld;
  hole.viewToGreen = tViewToGreen;
  hole.greenToView = tGreenToView;

  let pinPlacementData = hole && hole.PinPlacements.map((item) => item);
  var updatedPinData = [...pinPlacementData];

  Object.defineProperties(hole, {
    UpdatedPinData: {
      value: updatedPinData,
      writable: true,
      enumerable: true,
      configurable: true,
    },
  });

  if (boundariesUnset) initializeGreenAndGrid(hole);
};
